export default function Modal({ title, onClose, children, wide = false, zIndex = 1000 }) {
  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        background: "#000b",
        zIndex,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 16,
      }}
      onClick={(e) => e.target === e.currentTarget && onClose()}
    >
      <div
        style={{
          background: "linear-gradient(135deg,#0f172a,#1e293b)",
          border: "1px solid #1e3a5f",
          borderRadius: 20,
          padding: 28,
          width: "100%",
          maxWidth: wide ? 820 : 520,
          maxHeight: "90vh",
          overflowY: "auto",
          boxShadow: "0 24px 64px #000c",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: 22,
          }}
        >
          <h3
            style={{
              color: "#f1f5f9",
              fontSize: 18,
              fontWeight: 800,
              margin: 0,
            }}
          >
            {title}
          </h3>
          <button
            onClick={onClose}
            style={{
              background: "none",
              border: "none",
              color: "#64748b",
              cursor: "pointer",
              fontSize: 22,
            }}
          >
            ✕
          </button>
        </div>
        {children}
      </div>
    </div>
  );
}
